import React from "react";
import styles from "./About.module.css";

interface AboutProps {
  title: string;
  description: string;
  subsections?: { title: string; content: string }[];
}

const About: React.FC<AboutProps> = ({ title, description, subsections }) => {
  return (
    <section id="about" className={styles.aboutSection}>
      <div className="container">
        <div className={styles.container}>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.description}>{description}</p>
        </div>
        <div className={styles.subContainer}>
          <div className={styles.aboutGrid}>
            {subsections &&
              subsections.map((subsection, index) => (
                <div key={index} className={styles.aboutCard}>
                  <h3 className={styles.subTitle}>{subsection.title}</h3>
                  <p className={styles.subDescription}>{subsection.content}</p>
                </div>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
